var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStrapi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_46_12985)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.4977 0H7.67493V7.93341H15.4605C15.7378 7.93341 15.9628 8.15842 15.9628 8.43579V16.1139H24V0.5033C24.0003 0.369901 23.9475 0.241882 23.8532 0.147469C23.759 0.0530552 23.6311 0 23.4977 0Z",
    fill: "#8E75FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.405,
    d: "M7.67397 0V7.93341H0.251211C0.149213 7.93323 0.0574112 7.87149 0.0187676 7.7771C-0.0198761 7.6827 0.00228209 7.57432 0.0748728 7.50266L7.67397 0ZM16.3908 23.6248C16.3185 23.6958 16.2108 23.7165 16.1173 23.6774C16.0239 23.6383 15.963 23.547 15.9628 23.4457V16.1139H24L16.3908 23.6239V23.6248Z",
    fill: "#8E75FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.405,
    d: "M7.67401 7.93335H15.7121C15.8499 7.93335 15.9628 8.0454 15.9628 8.18408V16.1138H8.17731C7.89985 16.1138 7.67493 15.8889 7.67493 15.6114V7.93335H7.67401Z",
    fill: "#8E75FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_46_12985"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrapi);
export default __webpack_public_path__ + "static/media/strapi.e21b0698659e3db3f20fb148dd4fd215.svg";
export { ForwardRef as ReactComponent };